import { StyledLogoContainer, StyledText } from './MainScreen.styles'

export const Future = () => {
    return (
        <StyledLogoContainer>
        <StyledText> 
        "I think we can agree, the past is over"
           <br></br> 
                     ~ Gorge W. Bush
                     <br></br> 
                     <br></br> 
                     Plans for future:
            <br></br> 
            -Finding founders for better ending
            <br></br> 
            -Creating part 2 - better and more interesting
            <br></br> 
            -Giving this duck more kind of bread (The duck is bored)
            <br></br> 
            -Creating website that will connect more games
            <br></br> 
            -Adding adverbs somewhere on the site if founder won't be find 
            <br></br>
            (Bread is expensive and duck eats a lot o.o )
        </StyledText>
        </StyledLogoContainer>
    )
}

export default Future;